export const temporaryQueryConstructor = (array: any[]) => {
  return array.join(" OR ");
};

export const temporaryQuery = (array: string[]): string => {
  return array.map((item) => `"${item}"`).join(" OR ");
};
